import * as React from "react"

import { GlobalState } from "../../../../../../store"
import { fetchWorkspace } from "../../../../../resources/thunks"
import { useAppDispatch, useAppSelector } from "../../../../../../hooks"
import { workspaceSelector } from "../../../../../resources/adapters"

import Link from "../Link"
import UnavailableLink from "../UnavailableLink"

interface Props {
    attributes: Record<string, string>
    label: string
    workspaceId: number
}

export const WorkspaceTutorial = ({
    attributes,
    label,
    workspaceId,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector((state: GlobalState) => state.resources)
    const workspace = workspaceSelector.selectById(resources, workspaceId)

    React.useEffect(() => {
        if (!workspace) {
            dispatch(fetchWorkspace(workspaceId))
        }
    }, [])

    if (!workspace) {
        return (
            <UnavailableLink
                attributes={attributes}
                label={label}
                isLoading={true}
            />
        )
    } else if (workspace.doesExist) {
        const href = `workspace/${workspace.id}/tutorial`

        return <Link attributes={attributes} label={label} href={href} />
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default WorkspaceTutorial
